import type { WahaSessionStatusSocketMessage } from '@/shared/socket/waha/types';

type SessionStatusListener = (message: WahaSessionStatusSocketMessage) => void;

const listeners = new Set<SessionStatusListener>();

export function publishWahaSessionStatus(
  message: WahaSessionStatusSocketMessage,
): void {
  for (const listener of listeners) {
    listener(message);
  }
}

export function subscribeWahaSessionStatus(
  listener: SessionStatusListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
